// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "0.0.11/static/css/" + "main" + "." + "e35f39af" + ".css";
};